<script setup>
import { ref } from 'vue';
import ModalBase from '@/components/utils/ModalBase.vue';
import ModalBody from '@/components/utils/ModalBody.vue';
import ActionEdit from './ActionEdit.vue';

const props = defineProps({
  orderId: { type: Number, default: null },
  demPointsForMap: { type: Array, default: null },
  actionsWithNoDemPointForMap: { type: Array, default: null }
});
const emit = defineEmits(['succeeded']);
const modalBase = ref();
const actionEditKey = ref(0);
const actionToEditId = ref(null);
const modalTitle = ref('Edytuj akcję');

function show(actionId) {
  actionToEditId.value = actionId;
  modalBase.value.show();
  actionEditKey.value++;
}

function onActionSuccessfullyUpdated() {
  modalBase.value.hide();
  emit('succeeded');
}

function onModalTitleChanged(newTitle) {
  modalTitle.value = newTitle;
}

defineExpose({ show });
</script>

<template>
  <ModalBase ref="modalBase">
    <ModalBody>
      <template v-slot:title> {{ modalTitle }} </template>
      <template v-slot:body>
        <ActionEdit
          v-if="actionEditKey > 0"
          :key="actionEditKey"
          :orderId="props.orderId"
          :actionId="actionToEditId"
          :demPointsForMap="props.demPointsForMap"
          :actionsWithNoDemPointForMap="props.actionsWithNoDemPointForMap"
          @succeeded="onActionSuccessfullyUpdated"
          @modalTitleChanged="onModalTitleChanged"
        />
      </template>
    </ModalBody>
  </ModalBase>
</template>

<style scoped></style>
